import React from 'react'
import { Link } from 'react-router-dom'

function ThankYou() {
  return (
    <div>
        
    <div className="section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    <div className="error-page text-center">
                        <div className="image mb-xl-30">
                            <img src="/tm/react/toolways/assets/images/thankyou.jpg" className="img-fluid" alt="img"/>
                        </div>
                        <p>Check your all orders go your Account Page</p>
                        <Link to="/account" className="thm-btn btn-rounded thm-bg-color-one">My Account</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  )
}

export default ThankYou